import { ToastType } from './../toast/toast.enum';
import { AuthService, User } from './../user/auth.service';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { RegistryService } from '../registry/registry.service';
import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { PaymentService } from '../payment/payment.service';
import { CartService } from '../cart/cart.service';
import { TrackedGiftCollection } from '../payment/tracked-gift-collection';
import { TrackedGift } from '../payment/tracked-gift';
import { Router, ActivatedRoute } from '@angular/router';
import { SettingsService } from '../settings/settings.service';
import { FormGroup, FormArray, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Gift } from '../gift/gift';
import { GiftSelection } from '../gift/giftSelection';
import { Registry } from './../registry/registry';
import { GuestWish } from './wish';
import { CustomValidatorsService } from '../shared/validators.service';
import { loadPayengine } from 'payengine';
import { environment } from '../../environments/environment';
import { timeout } from 'rxjs/operators';
@Component({

  selector: 'app-gift-wish',
  templateUrl: './gift-wish.component.html',
  styleUrls: ['./gift-wish.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GiftWishComponent implements OnInit, AfterViewInit {

  @Input() isCart = false;
  @Input() paymentId: string;
  @Input() guestLast4: string;
  @Input() guestPaymentTotal: number;
  @Input() numberOfGiftsBought: number;
  @Input() paymentNames: string;
  @Input() guestpaymentGiftSubTotal: number;
  @Output() itemWished: EventEmitter<any>;

  public hitchdForm: FormGroup;
  loaded: boolean = false;
  registry: Registry;
  user: User;
  wishText:string;
  isLoggedIn = false;
  private dcoupleNames: string;
  private giftSelection: GiftSelection;
  private guestPartnerName: string;
  public firstName: string;
  private yourName: string;
  private uploadPhotoText = 'Upload your photo';
  submitting: boolean = false;
  symbol: string;
  guestPicUrl: string;
  partnersName: string
  guestName:string
  giftUrlName: string;
  giftTitle: string;
  preview = false;
  showTranslation: boolean;
  guestEmail: string;
  constructor(
    private _paymentService: PaymentService,
    private route: ActivatedRoute,
    private router: Router,
    private _settingsService: SettingsService,
    private _fb: FormBuilder,
    private _registryService: RegistryService,
    private validatorService: CustomValidatorsService,
    private _registryFirebaseService: RegistryFirebaseService,
    private _cartService: CartService,
    private _authService: AuthService

  ) {
    this.itemWished = new EventEmitter<any>();
    this.registry = this.route.snapshot.data.registry;
    this.isLoggedIn = this.route.snapshot.data.isLoggedIn;
    //this.gifts = this.route.snapshot.data.gifts;
    if (this.registry && (location.search.includes('preview'))) {
      // this.router.navigate(["coming-soon"]);
      this.preview = true;


    }
    if(localStorage.getItem('showTranslation')){
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }
    const previousGiftSelection: GiftSelection = JSON.parse(localStorage.getItem('giftSelection'));
    if  (!previousGiftSelection){
      const giftname =  this._registryService.giftTitle;
      if(this.isLoggedIn){
        this.router.navigate(['/registry', giftname]);
      }else{
      this.router.navigate(['/' + this.registry.registryName.toLocaleLowerCase(), giftname]);
      }
    }

    if (!this.isCart && previousGiftSelection && previousGiftSelection.gift) {
      this.guestPaymentTotal = previousGiftSelection.price;
      this.giftTitle = previousGiftSelection.gift.title;
      this.giftUrlName = previousGiftSelection.gift.friendlyUrl.toLowerCase();
      this.loaded = true;
    } else {

      const cart = this._cartService.getCart();
      let sum = cart.cartItems.reduce((x, cv) => x + cv.price, 0);
      this.guestPaymentTotal = sum;
      this.loaded = true;

    }

    let guestWish =  this._registryService.getWish();
    if (guestWish) {
    this.wishText = guestWish.wishText;
    this.partnersName = guestWish.partnersName
    this.guestName = guestWish.yourName;
    this.guestEmail = guestWish.email;
    }



  }

    async ngOnInit() {

    if(localStorage.getItem('showTranslation')){
      this.showTranslation = true;
    } else {
      this.showTranslation = false;
    }


    this.symbol = this.registry.symbol;
  
    this.hitchdForm = this._fb.group({
      Message: ['', [Validators.required, Validators.minLength(1), Validators.maxLength(3000)]],
      GuestPartnerName: [''],
      GuestPicUrl: ['', []],
      YourNames: [this.paymentNames, [Validators.required]],
      Email: ['', [this.validatorService.emailWithTLD, Validators.required]],
    });
    this.loaded = true;
    this.yourName = this.paymentNames;
    this.firstName = this.paymentNames;

    if (this.paymentNames && this.paymentNames.indexOf(' ') > 0) {
      this.firstName = this.paymentNames.split(' ')[0]
    }
    this.hitchdForm.controls['YourNames'].markAsTouched();

    window.scrollTo(0, 0);    
    this.initializePaymentEngine();
  }

  private async initializePaymentEngine() {
    console.log('initializePaymentEngine called, registry:', this.registry);
    if (this.registry) {
      try {

        let settings = await this._registryFirebaseService.getSettingsByUserId(this.registry.userId).toPromise();
        if (settings.merchantId) {
          let payEngine = await loadPayengine(environment.payengine.PAYENGINE_LOADER_CONFIG);
          const sessionId = await payEngine.createFraudMonitorSession(settings.merchantId);
          localStorage.setItem('payengineSessionId', sessionId);
          localStorage.setItem('payengineMerchantId', settings.merchantId);
          console.log('sessionId', sessionId);
          console.log('merchantId', settings.merchantId);
        } else {
          console.log('No merchantId found, skipping payment engine initialization');
        }
      } catch (error) {
        console.error('Error initializing payment engine:', error);
        // Continue without payment engine initialization
      }
    }
  }


  openUploader() {

    document.getElementById('file_input_id').click();
  }


  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 1;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 26); // 20px = line-height: 1.25rem
    this.hitchdForm.markAsTouched();
  }


  handledUploadedImage(event: any) {

    if (event) {
      event = event + '?hex=ffffff';
      if (this.hitchdForm) {
        this.hitchdForm.markAsTouched();
        this.guestPicUrl = event;
        this.hitchdForm.controls['GuestPicUrl'].setValue(event);

      }
    }
  }




  ngAfterViewInit(): void {
    const textarea: HTMLTextAreaElement = <HTMLTextAreaElement>document.getElementById('introtext');
    //
    if (textarea) {
      textarea.value = textarea.value + '';
      this.expandTextArea(textarea);
    }
    window.scroll(0, 0);
  }

  save() {
    this.submitting = true;
    const guestWish = new GuestWish();
    this.yourName = this.hitchdForm.controls['YourNames'].value;
    guestWish.wishText = this.hitchdForm.controls['Message'].value;
    guestWish.email = this.hitchdForm.controls['Email'].value;
    this.guestPartnerName = this.hitchdForm.controls['GuestPartnerName'].value;
    guestWish.partnersName = this.guestPartnerName;
    guestWish.yourName = this.yourName;
    if (this.guestPartnerName && this.guestPartnerName.length > 0) {


      guestWish.fromNames = this.yourName + " & " + this.guestPartnerName;
    } else {

      guestWish.fromNames = this.yourName;
    }
    this.submitting = false;
    if (this.hitchdForm.valid) {
      guestWish.registryId = this.registry.id;
      this._registryService.wish = guestWish;
      if (this.isCart) {

        guestWish.contribution = this._cartService.giftTotal().toLocaleString('en-US');
        this.itemWished.emit('wished');
        return;
      }

      guestWish.contribution = this.guestPaymentTotal.toLocaleString('en-US');
      let returnAddress = "/"+     this.registry.registryName
      if(location.href.toLowerCase().includes('/registry/')){
        returnAddress =  "/"+     this.registry.registryName +"/registry"
      }
      if (!this.isLoggedIn) {
        let contributionUrlPath = '/contribute'
        if (this.preview){
          contributionUrlPath = '/contribute?preview=1'
        }
        this.router.navigateByUrl(returnAddress +"/"+ this.giftUrlName + contributionUrlPath);
      } else if (this.preview){
        this.router.navigate([returnAddress +"/"+  this.giftUrlName + '/contribute?preview=1'] );
      }else {
        this.router.navigate([returnAddress +"/"+  this.giftUrlName + '/contribute']);
        return;
      }

    }
  }

}




// WEBPACK FOOTER //
// ./src/app/gift-wish/gift-wish.component.ts